import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../../services/api';
import './Master.css';

export default function Master({ user }) {
  const companyId = user?.Companyid || user?.company_id || "1";

  const [tab, setTab] = useState('Products');
  const [productList, setProductList] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [productId, setProductId] = useState(null);

  const emptyForm = {
    Name: '',
    Category: '',
    Units: 'Liters',
    Rate: '',
    HSNCode: '',
    GstPer: '',
    Status: 'Active'
  };

  const [form, setForm] = useState(emptyForm);

  /* ================= FETCH PRODUCTS ================= */

  const fetchProducts = async () => {
    try {
      const res = await fetch(`${BASE_URL}Pages/ProductView.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Companyid: companyId })
        }
      );

      const data = await res.json();
      if (data.success && data.Response) {
        const list = Array.isArray(data.Response)
          ? data.Response
          : [data.Response];

        const formatted = list.map(p => ({
          id: p.Productid,
          code: p.Name ? p.Name.substring(0,3).toUpperCase() : 'PRD',
          name: p.Name,
          hsnCode: p.HSNCode,
          unit: p.Units,
          category: p.Category || 'General',
          taxPer: parseFloat(p.GstPer) || 0,
          rate: p.Rate || 0,
          status: p.Status || 'Active'
        }));
        setProductList(formatted);
      }
    } catch (err) {
      console.error("Product fetch error:", err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [companyId]);

  const handleEdit = (p) => {
    setProductId(p.id);
    setForm({
      Name: p.name,
      Category: p.category,
      Units: p.unit,
      Rate: String(p.rate),
      HSNCode: p.hsnCode,
      GstPer: String(p.taxPer),
      Status: p.status
    });
    setShowForm(true);
  };

  /* ================= FORM CHANGE ================= */

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  /* ================= SAVE PRODUCT ================= */

  const handleSaveProduct = async () => {

    if (!form.Name.trim()) {
      alert("Product Name is required");
      return;
    }

    if (!form.Category.trim()) {
      alert("Category is required");
      return;
    }

    if (!form.Units) {
      alert("Units is required");
      return;
    }

    if (!form.Rate || Number(form.Rate) <= 0) {
      alert("Rate must be greater than 0");
      return;
    }

    if (!form.HSNCode.trim()) {
      alert("HSN Code is required");
      return;
    }

    if (form.GstPer === "") {
      alert("GST % is required");
      return;
    }

    if (form.GstPer < 0 || form.GstPer > 30) {
      alert("GST must be between 0 and 30");
      return;
    }

    if (!form.Status) {
      alert("Status is required");
      return;
    }

    const payload = {
      Companyid: companyId,
      ...form,
      IDS: productId ? productId.toString() : "0"
    };

    try {
      const res = await fetch(`${BASE_URL}Pages/ProductReg.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const data = await res.json();
      if (data.success || data.Response === "UPDATED" || data.Response === "INSERTED") {
        alert(productId ? "Product Updated Successfully" : "Product Added Successfully");
        setShowForm(false);
        setForm(emptyForm);
        setProductId(null);
        fetchProducts();
      } else {
        alert(data.message || "Failed to save product");
      }
    } catch (err) {
      console.error("Product save error:", err);
      alert("Error saving product");
    }
  };

  /* ================= ADD BUTTON ================= */

  const handleAddNew = () => {
    if (tab === 'Products') {
      setProductId(null);
      setForm(emptyForm);
      setShowForm(true);
    }
  };

  return (

<div className="master-page">

{/* ================= PAGE HEADER ================= */}

<div className="page-header">

<h2 className="page-title">Master / Product</h2>

<button className="btn btn-primary btn-sm" onClick={handleAddNew}>
＋ Add New
</button>

</div>


{/* ================= PRODUCT FORM ================= */}

{showForm && (

<div className="section-card">

<div className="section-header">
{productId ? 'Edit Product' : 'Add Product'}
</div>

<div className="form-row">

<div className="form-group">
<label>Product Name <span className="required">*</span></label>
<input
className="form-control"
name="Name"
value={form.Name}
onChange={handleChange}
required
disabled={!!productId}
/>
</div>

<div className="form-group">
<label>Category <span className="required">*</span></label>
<input
className="form-control"
name="Category"
value={form.Category}
onChange={handleChange}
required
/>
</div>

<div className="form-group">
<label>Units <span className="required">*</span></label>
<select
className="form-control"
name="Units"
value={form.Units}
onChange={handleChange}
required
>
<option value="">Select Units</option>
<option value="Liters">Liters</option>
<option value="No's">No's</option>
</select>
</div>

<div className="form-group">
<label>Rate <span className="required">*</span></label>
<input
type="number"
className="form-control"
name="Rate"
value={form.Rate}
onChange={handleChange}
required
/>
</div>

<div className="form-group">
<label>HSN Code <span className="required">*</span></label>
<input
className="form-control"
name="HSNCode"
value={form.HSNCode}
onChange={handleChange}
required
/>
</div>

<div className="form-group">
<label>GST % <span className="required">*</span></label>
<input
type="number"
className="form-control"
name="GstPer"
value={form.GstPer}
onChange={handleChange}
required
/>
</div>

<div className="form-group">
<label>Status <span className="required">*</span></label>
<select
className="form-control"
name="Status"
value={form.Status}
onChange={handleChange}
required
>
<option value="Active">Active</option>
<option value="Inactive">Inactive</option>
</select>
</div>

</div>

<div className="action-bar" style={{ padding: '0 16px 14px' }}>

<button className="btn btn-primary" onClick={handleSaveProduct}>
  <i className="bi bi-save me-1"></i> {productId ? "Update Product" : "Save Product"}
</button>

<button
className="btn btn-secondary"
onClick={() => setShowForm(false)}
>
✕ Cancel
</button>

</div>

</div>

)}


{/* ================= PRODUCTS TABLE ================= */}

{tab === 'Products' && (

<div className="section-card">

<div className="section-header">
Product Master
</div>

<div className="table-wrapper">

<table className="data-table">

<thead>

                <tr>
                  <th className="text-center">Code</th>
                  <th className="text-left">Product Name</th>
                  <th className="text-left">Category</th>
                  <th className="text-left">HSN Code</th>
                  <th className="text-center">Unit</th>
                  <th className="text-right">Tax %</th>
                  <th className="text-right">Rate (₹)</th>
                  <th className="text-center">Action</th>
                </tr>

</thead>

<tbody>

{productList.map(p => (

                <tr key={p.id}>
                  <td className="text-center">
                    <span className="badge badge-primary">{p.code}</span>
                  </td>
                  <td className="text-left" style={{ fontWeight: 600 }}>{p.name}</td>
                  <td className="text-left">{p.category}</td>
                  <td className="text-left" style={{ fontFamily: 'monospace' }}>{p.hsnCode}</td>
                  <td className="text-center">{p.unit}</td>
                  <td className="text-right">{p.taxPer}%</td>
                  <td className="text-right" style={{ fontWeight: 700 }}>
                    ₹{parseFloat(p.rate || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </td>
                  <td className="text-center">
                    <button className="icon-btn" onClick={() => handleEdit(p)}>
                      <i className="bi bi-pencil-square"></i>
                    </button>
                  </td>
                </tr>

))}

</tbody>

</table>

</div>

</div>

)}

</div>
);
}